import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { cn } from "../../lib/cn";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  /** Accessible label — required because icon-only buttons need it. */
  label: string;
  variant?: "ghost" | "subtle";
  size?: "sm" | "md";
}

export const IconButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      icon,
      label,
      variant = "ghost",
      size = "md",
      className,
      type = "button",
      ...rest
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        aria-label={label}
        title={label}
        className={cn(
          "inline-flex items-center justify-center rounded-md",
          "text-text-tertiary transition-colors duration-fast ease-out",
          "hover:text-text-primary hover:bg-bg-inset",
          "disabled:opacity-40 disabled:pointer-events-none",
          size === "sm" ? "h-7 w-7" : "h-8 w-8",
          variant === "subtle" && "bg-bg-inset text-text-secondary",
          className,
        )}
        {...rest}
      >
        {icon}
      </button>
    );
  },
);
IconButton.displayName = "IconButton";
